{
  "pt": {
    "session": {
      "error_internalserver": {
        "goback": "Voltar atrás",
        "subtitle": "Oops, parece ter ocorrido um erro inesperado.",
        "title": "500"
      },
      "error_notfound": {
        "goback": "Voltar atrás",
        "subtitle": "Lamentamos, mas não foi possível encontrar a página que procura.",
        "title": "404"
      },
      "expired": {
        "text": "A sua sessão expirou devido a inatividade. Por motivos de segurança, é-lhe pedido que inicie sessão novamente. \n\nClique em OK para ser redireccionado para o ecrã de início de sessão.",
        "title": "Sessão expirada"
      },
      "logout_impersonate": {
        "text": "Foi desencadeada uma ação de logout durante a personificação.",
        "title": "Imitação interrompida"
      },
      "noaccess": {
        "text": "Poderá ser afetado pela nossa mais recente <b>atualização</b>: <p></p> <ul> <li>&nbsp;</li> <li><b>Membros da equipa e parceiros</b> agora têm acesso via <b>ziggu.app</b> (em vez de <i>%company%</i>.ziggu.app)</li> <li>&nbsp;</li> <li><b>Clientes</b> não são afetados e podem continuar a aceder à plataforma via <b><i>%company%</i>.ziggu.app</b> </ul> <p>&nbsp;</p> <p>Ao clicar em OK será redirecionado para a página apropriada. Para problemas, contacte-nos.</p>",
        "title": "Oops.. parece que já não tem acesso a esta página."
      }
    }
  }
}
